module.exports = window["wp"]["autop"];